import { TLanguage } from '@simOn/common/language';

export const RELOAD_PAGE_AFTER_CHANGE_LANGUAGE = (language: TLanguage, url: string) => {
  if (!location.href.includes(`/${language}/`)) {
    location.href = location.origin + `/${language}` + url;
  }
};
